export const pluralize = (count, word, special_plural) => {
  if(count <= 0) return ''

  if(count == 1) return `${count} ${word}`

  if(count > 1) return `${count} ${special_plural || word + 's'}`
}
